import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Address, User } from "../../types/slice.types";
import {
  addUserAddress,
  deleteUserAddress,
  updateUserAddress,
} from "../../services/address.services";
import { editProfileCall } from "../../services/authService";

interface AuthState {
  user: User | null;
  token: string | null;
  isLoading: boolean;
}

const initialState: AuthState = {
  user: null,
  token: null,
  isLoading: true,
};

export const addAddress = createAsyncThunk(
  "add/UserAddress",
  async (address: Address, { rejectWithValue }) => {
    const { data, error } = (await addUserAddress(address)) as {
      data: { addresses: Address[] };
      error: any;
    };

    if (error) rejectWithValue(error);

    return data;
  }
);

export const updateAddress = createAsyncThunk(
  "update/UserAddress",
  async (address: Address, { rejectWithValue }) => {
    const { data, error } = (await updateUserAddress(address)) as {
      data: { addresses: Address[] };
      error: any;
    };
    if (error) rejectWithValue(error);

    return data;
  }
);

export const deleteAddress = createAsyncThunk(
  "delete/UserAddress",
  async (addressId: string, { rejectWithValue }) => {
    const { data, error } = (await deleteUserAddress(addressId)) as {
      data: { addresses: Address[] };
      error: any;
    };
    if (error) rejectWithValue(error);
    return data;
  }
);

export const editProfile = createAsyncThunk(
  "edit/UserProfile",
  async (profileData: Partial<User>, { rejectWithValue }) => {
    const { data, error } = (await editProfileCall(profileData)) as {
      data: User;
      error: any;
    };
    if (error) rejectWithValue(error);
    return data;
  }
);

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (state, action: PayloadAction<{ user: User; token: string }>) => {
      state.user = action.payload.user;
      state.token = action.payload.token;
    },
    logout: (state) => {
      state.user = null;
      state.token = null;
    },
    setAuthCompleted: (state) => {
      state.isLoading = false;
    },
  },
  extraReducers(builder) {
    builder.addCase(addAddress.fulfilled, (state, action) => {
      const payload = action.payload;
      if (state.user && payload.addresses) {
        state.user.addresses = payload.addresses;
      }
    });
    builder.addCase(updateAddress.fulfilled, (state, action) => {
      const payload = action.payload;
      if (state.user && payload.addresses) {
        state.user.addresses = payload.addresses;
      }
    });
    builder.addCase(deleteAddress.fulfilled, (state, action) => {
      const payload = action.payload;
      if (state.user && payload.addresses) {
        state.user.addresses = payload.addresses;
      }
    });
    builder.addCase(editProfile.fulfilled, (state, action) => {
      const payload = action.payload;
      state.user = { ...state.user, ...payload };
    });
  },
});

export const { login, logout, setAuthCompleted } = authSlice.actions;
export default authSlice.reducer;
